const SubtractOperator = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13" width="13" height="13">
            <path fill="none" stroke="currentColor" strokeLinecap="square" d="M2.5 6.5h8"></path>
        </svg>
    )
}
export default SubtractOperator